import getPreviousStep from "state/getPreviousStep";

const hasPreviousStep = currentStep => Boolean(getPreviousStep(currentStep));

export default hasPreviousStep;



// WEBPACK FOOTER //
// ./src/state/hasPreviousStep.js